import { HEADERS_JSON } from "@/common/api/constants";
import { CommonRequestProps, CommonResponse } from "@/common/api/types";
import { responseHandler } from "@/common/api/utils";
import { API_URL } from "@/config";
import {
  KDPTokenResponse,
  LatestLeadResponse,
  LeadApplyRequest,
  LeadApplyResponse,
  PostEmploymentContractProps,
  PostLeadParamsProps,
} from "@/entities/lead/api/types";

export const fetchLatestLead = async ({
  setErrorMessage,
  token,
}: CommonRequestProps<{ token: string }>) => {
  const response = await fetch(`${API_URL}/cabinet/latest-lead`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      ...HEADERS_JSON,
    },
  });
  const handledResponse = await responseHandler({ response, setErrorMessage });
  return (await handledResponse?.json())?.data as LatestLeadResponse;
};

export const postLeadApply = async ({
  token,
  data,
  setErrorMessage,
}: CommonRequestProps<{
  token: string;
  data: LeadApplyRequest;
}>): Promise<LeadApplyResponse> => {
  const response = await fetch(`${API_URL}/cabinet/apply-for-loan`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      ...HEADERS_JSON,
    },
    body: JSON.stringify(data),
  });
  const handledResponse = await responseHandler({ response, setErrorMessage });
  return await handledResponse.json();
};

export const postKDPTokenRequest = async ({
  token,
  setErrorMessage,
}: CommonRequestProps<{
  token: string;
}>): Promise<CommonResponse<KDPTokenResponse>> => {
  const response = await fetch(`${API_URL}/cabinet/request-kdp-token`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      ...HEADERS_JSON,
    },
    body: "",
  });
  const handledResponse = await responseHandler({ response, setErrorMessage });
  return await handledResponse.json();
};

export const postEmploymentContract = async ({
  token,
  data,
  setErrorMessage,
}: CommonRequestProps<{
  token: string;
  data: PostEmploymentContractProps;
}>): Promise<Response> => {
  const response = await fetch(`${API_URL}/cabinet/lead/select-employment`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      ...HEADERS_JSON,
    },
    body: JSON.stringify(data),
  });
  return await responseHandler({ response, setErrorMessage });
};

export const postLeadParams = async ({
  token,
  data,
  setErrorMessage,
}: CommonRequestProps<{
  token: string;
  data: PostLeadParamsProps;
}>): Promise<Response> => {
  const response = await fetch(`${API_URL}/cabinet/lead/select-date-and-sum`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      ...HEADERS_JSON,
    },
    body: JSON.stringify(data),
  });
  return await responseHandler({ response, setErrorMessage });
};
